const components = () => {
  jQuery(document).ready(function ($) {
    //header
    $(document).scroll(function () {
      if ($(window).scrollTop() === 0) {
        $("#desktop-header").removeClass('scrolling');
      } else {
        $("#desktop-header").addClass('scrolling');
      }
    }); //faq

    var dateFormat = require("dateformat");

    var now = new Date();
    window.bookingData = {
      booking_date: dateFormat(now, "yyyy/mm/dd"),
      service_id: 0,
      step_position: 1
    };
    $('.custom-category').click(function () {
      $(this).toggleClass('active', 500);
      var parent = $(this).parents('.wc-listing');
      $('.wc-items-container', parent).toggleClass('active', 500);
    }); //Service Details

    $('.dropdown-title').click(function () {
      // console.log('dropdeon');
      $(this).toggleClass('active', 1000);
      var parent = $(this).parents('.wc-container');
      $('.wc-accordion', parent).toggleClass('active', 1000);
    });
    $('#back-btn').click(function () {
      var pos = bookingData.step_position - 1;
      $('#step' + pos).trigger('click');
    });
    $('video').click(function () {
      this.paused ? this.play() : this.pause();
      $('.play-icon').toggleClass('active');
    }); // ************CORPORATE PAGE***********
    //  Collaboration Partners Slider

    $(".partner-section__img-slider").not('.slick-initialized').slick({
      adaptiveHeight: false,
      mobileFirst: true,
      autoplay: true,
      autoplaySpeed: 4000,
      arrows: false,
      dots: false,
      infinite: true,
      centerMode: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      centerPadding: '20px'
    }); //  Lipstick Carousell

    $(".product-carousell__img-slider").not('.slick-initialized').slick({
      adaptiveHeight: false,
      mobileFirst: true,
      autoplay: false,
      autoplaySpeed: 4000,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      focusOnSelect: true,
      centerMode: true,
      responsive: [{
        breakpoint: 767,
        settings: {
          slidesToShow: 4
        }
      }]
    }); // Single image Lightbox

    $('.step-title-container, .step-image-container').slickLightbox({
      itemSelector: 'a'
    }); // carousell images Lightbox

    $('#coorporate-slider').slickLightbox({
      itemSelector: 'a'
    }); //Booking

    $('#step1').click(function () {
      if (bookingData.step_position > 0) {
        bookingData['step_position'] = 1;
        $('.step-section-container').removeClass('active');
        $('#step-1-container').addClass('active');
        $('.step-nav').removeClass('active');
        $(this).addClass('active');
        $('#back-btn').removeClass('active');
      }
    });
    $('#step2').click(function () {
      if (bookingData.step_position > 2) {
        bookingData['step_position'] = 2;
        $('.step-section-container').removeClass('active');
        $('#step-2-container').addClass('active');
        $('.step-nav').removeClass('active');
        $(this).addClass('active');
        $('#back-btn').addClass('active');
      }
    });
    $('#step3').click(function () {
      if (bookingData.step_position == 4) {
        bookingData['step_position'] = 3;
        $('.step-section-container').removeClass('active');
        $('#step-3-container').addClass('active');
        $('.step-nav').removeClass('active');
        $(this).addClass('active');
        $('#back-btn').addClass('active');
      }
    });
    $('#step4').click(function () {
      if (bookingData.step_position > 4) {
        $('.step-section-container').removeClass('active');
        $('#step-4-container').addClass('active');
        $('#back-btn').addClass('active');
      }
    });
    $('.step-section-container').on('click', '.view-details', function () {
      var parent = $(this).parents('.service-step-container');
      $(this).removeClass('active');
      $('.hide-details', parent).addClass('active');
      $('.details-section', parent).toggleClass('active');
    });
    $('.step-section-container').on('click', '.hide-details', function () {
      var parent = $(this).parents('.service-step-container');
      $(this).removeClass('active');
      $('.view-details', parent).addClass('active');
      $('.details-section', parent).toggleClass('active');
    });
    $('#step-1-container').on('click', '.select-btn', function () {
      $('.step-section-container').removeClass('active');
      $('.step-nav').removeClass('active');
      $('#step2').addClass('active');
      $('#back-btn').addClass('active');
      bookingData['step_position'] = 2;
      bookingData['service_id'] = $(this).attr('data-id');
      bookingData['service_category'] = $(this).attr('data-category');
      var parent = $(this).parents('.service-step-container');
      $('.details-section', '#step-1-container').removeClass('active');
      $(this).addClass('selected');
      $('.select-btn', '#step-1-container').removeClass('selected');
      $('#step1 .selection').text($('#service-name', parent).text());
      bookingData['name'] = $('#service-name', parent).text();
      bookingData['duration_text'] = $('#duration-text', parent).text();
      bookingData['amount'] = $(this).attr('data-amount');
      bookingData['price'] = $(this).attr('data-price');
      var cat = $(this).attr('data-category');
      bookingData['category'] = cat;

      if (cat == "single") {
        $('#single-form').show();
        $('#party-form').hide();
      } else {
        $('#single-form').hide();
        $('#party-form').show();
      }

      $('#step-2-container').addClass('active'); // assign the campaign terms

      jQuery('#campaign_terms_wrapper').html(jQuery(this).data('terms'));
      get_locations();
    });
    $('#step-2-container').on('click', '.select-btn', function () {
      // location
      var parent = $(this).parents('.service-step-container');
      var guest = $('.guest_count', parent).val();

      if (guest == 0) {
        alert('Please select number of guest. (請選擇訂製人數。)');
        return;
      }

      $('.step-section-container').removeClass('active');
      $('.step-nav').removeClass('active');
      $('#step3').addClass('active');
      $('#step2 .selection').text($(this).attr('data-location'));
      bookingData['step_position'] = 3;
      bookingData['provider_id'] = $(this).attr('data-id');
      bookingData['location'] = $(this).attr('data-location');
      bookingData['count'] = guest;
      get_timeslots();
      var parent = $(this).parents('.step-section-container');
      $(parent).removeClass('active');
      $('#step-3-container').addClass('active');

      if (bookingData.category == "party") {
        $('#occasion-container').show();
      } else {
        $('#occasion-container').hide();
      }
    });
    $('#step-3-container').on('click', '.time-wrapper', function () {
      // time
      $('.step-section-container').removeClass('active');
      $('.step-nav').removeClass('active');
      $('#step4').addClass('active');
      $('#step3 .selection').text($(this).text());
      bookingData['step_position'] = 4;
      bookingData['time'] = $(this).attr('data-id');
      bookingData['time_formatted'] = $(this).text();
      fill_summary();
      $('#step-4-container').addClass('active');
    }); //Date picker

    $('#datepicker').datepicker({
      dateFormat: 'yy/mm/dd'
    });
    $('.bdaypicker').datepicker({
      dateFormat: 'dd/mm/yy'
    });
    $('.datepiker-arrow-next').click(function () {
      var date_val = new Date($('#datepicker').val());
      var new_date = date_val.setDate(date_val.getDate() + 1);
      $('#datepicker').val(dateFormat(new_date, "yyyy/mm/dd"));
      $('#datepicker').trigger('change');
    });
    $('.datepiker-arrow-prev').click(function () {
      var date_val = new Date($('#datepicker').val());
      var old_date = dateFormat(date_val, "yyyy/mm/dd");
      var current_date = new Date();
      var today = dateFormat(current_date, "yyyy/mm/dd");

      if (today != old_date) {
        var new_date = date_val.setDate(date_val.getDate() - 1);
        $('#datepicker').val(dateFormat(new_date, "yyyy/mm/dd"));
        $('#datepicker').trigger('change');
      }
    });

    function convertTo12HourFormat(time24) {
      // Split the time into hours, minutes, and seconds
      let [hours, minutes, seconds] = time24.split(':'); // Convert hours from string to number

      hours = parseInt(hours, 10); // Determine AM or PM

      const period = hours >= 12 ? 'PM' : 'AM'; // Adjust hours for 12-hour format

      hours = hours % 12 || 12; // Pad minutes and seconds with leading zeros if necessary

      minutes = minutes.padStart(2, '0');
      seconds = seconds.padStart(2, '0'); // Return formatted time
      // return `${hours}:${minutes}:${seconds} ${period}`;

      return `${hours}:${minutes} ${period}`;
    }

    function fill_summary() {
      $('#guest-form-container').empty();
      $('#summary-service-name').text(bookingData.name);
      $('#summary-service-duration').text(bookingData.duration_text);
      $('#summary-service-amount').text(bookingData.amount);
      $('#summary-date-value').text(bookingData.booking_date);
      $('#summary-time-value').text(convertTo12HourFormat(bookingData.time));
      $('#summary-location-value').text(bookingData.location);
      $('#summary-count-value').text(bookingData.count);

      if (bookingData.category == "single") {
        if (bookingData.count > 1) {
          var template = $('#guest-form-template').html();

          for (var i = 0; i < bookingData.count - 1; i++) {
            var count = i + 2;
            var title = "<h3>Guest (客人) " + count + " Information</h3>";
            var temp = title + template;
            $('#guest-form-container').append(temp);
          }
        }
      } else {
        $('#guest-form-container').empty();
      }
    }

    $('#occasion-container .checkbox').click(function () {
      $('#occasion-container .checkbox').not(this).prop('checked', false);
      var parent = $(this).parents('.occasion-item');
      bookingData['occasion'] = $('span', parent).text();
      console.log(bookingData);
    }); //Booking final

    window.fill_confirmation = function (response) {
      var data = jQuery.parseJSON(response);
      bookingData['booking_code'] = data.primary_boooking_code;

      if (data.booking_status == "successful") {
        $('#booking-code').text(data.primary_boooking_code);
        $('#confirm-service-value').text(bookingData.name);
        $('#confirm-date-value').text(bookingData.booking_date);
        $('#confirm-time-value').text(bookingData.time_formatted);
        $('#confirm-location-value').text(bookingData.location);
        $('#confirm-count-value').text(bookingData.count);
        var promotion_code_text = '';

        if (bookingData.promo && bookingData.promo != '') {
          var total = bookingData.price * bookingData.count - bookingData.total_discount;
          promotion_code_text = bookingData.promo + ' (- HKD$ ' + bookingData.total_discount + ')';
          $('#confirm-promotion-value').text(promotion_code_text);
        } else {
          var total = bookingData.price * bookingData.count;
        }

        if (bookingData.category == "party") {
          $('#confirm-occasion-value').text(bookingData.occasion);
          $('#step-5-container .occasion-item').show();
          $('#occasion-container').show();
          $('#step-5-container .heading-container .confirm-party').addClass('active');
          $('#step-5-container .heading-container .confirm-single').removeClass('active');

          if (bookingData.promo && bookingData.promo != '') {
            $('#price-info-container').addClass('active');
            $('#price-info-container').addClass('onlyparty');
          }
        } else {
          $('#price-info-container').addClass('active');
          $('#confirm-price-value').text(bookingData.amount); // $('#confirm-promotion-value').text(bookingData.price);

          $('#confirm-total-value').text('HKD$ ' + total);
          $('#step-5-container .heading-container .confirm-party').removeClass('active');
          $('#step-5-container .heading-container .confirm-single').addClass('active');
        }

        $('#confirm-message-value').text($('#client-message').val()); // if(bookingData)
        // $('#confirm-name-value').text(bookingData.name);
        // $('#confirm-telephone-value').text(bookingData.name);
        // $('#confirm-email-value').text(bookingData.name);
        // $('#confirm-birthday-value').text(bookingData.name);

        $('.step-section-container').removeClass('active');
        $('#step-5-container').addClass('active');
      }
    };

    window.validate_form = function () {
      var empty = 0;
      $('#step-4-container input.required').each(function () {
        if (!$(this).val()) {
          var parent = $(this).parents('.half-input');
          $(parent).addClass('required');
          empty++;
        } else {
          var parent = $(this).parents('.half-input');
          $(parent).removeClass('required');
        }
      });

      if (empty > 0) {
        return "false";
      } else {
        return "true";
      }
    };

    $('#whatsapp-share').click(function () {
      var details = 'Booking Code: ' + bookingData.booking_code + '%0a' + 'Service: ' + bookingData.name + '%0a' + 'Date: ' + bookingData.booking_date + '%0a' + 'Starts at: ' + bookingData.time_formatted + '%0a' + 'Guests/s: ' + bookingData.count + '%0a' + 'Message: ' + bookingData.client_message + '%0a%0a';
      var primary = 'Guest 1' + '%0a' + 'Name: ' + bookingData.primary_user.first_name + '%0a' + 'Last Name: ' + bookingData.primary_user.last_name + '%0a' + 'Email: ' + bookingData.primary_user.email + '%0a' + 'Telephone: ' + bookingData.primary_user.telephone_number + '%0a%0a';
      var guests = "";

      for (var i = 0; i < bookingData.guests.length; i++) {
        var guest_no = i + 2;
        var g = 'Guest ' + guest_no + '%0a' + 'Name: ' + bookingData.guests[i].first_name + '%0a' + 'Last Name: ' + bookingData.guests[i].last_name + '%0a' + 'Email: ' + bookingData.guests[i].email + '%0a' + 'Telephone: ' + bookingData.guests[i].telephone_number + '%0a%0a';
        guests += g;
      }

      var total = bookingData.price * bookingData.count;
      var promotion_code_text = '';

      if (bookingData.promo && bookingData.promo != '') {
        if (bookingData.service_category == "single") {
          var total = bookingData.price * bookingData.count - bookingData.total_discount;
        }

        promotion_code_text = bookingData.promo + ' (- HKD$ ' + bookingData.total_discount + ')';
      }

      if (bookingData.service_category != "single") {
        var total = '';
        var cost = 'Discount: ' + promotion_code_text + '%0D%0A';
      } else {
        var cost = 'Price per person: ' + bookingData.amount + '%0a' + 'Discount: ' + promotion_code_text + '%0D%0A' + 'Total: HKD$ ' + total;
      }

      var sms = details + primary + guests + cost;
      var link = "https://wa.me/?text=" + sms; // window.location = link;

      $('<a href="' + link + '" target="_blank"></a>')[0].click();
    });
    $('#email-share').click(function () {
      var details = 'Booking Code: ' + bookingData.booking_code + '%0D%0A' + 'Service: ' + bookingData.name + '%0D%0A' + 'Date: ' + bookingData.booking_date + '%0D%0A' + 'Starts at: ' + bookingData.time_formatted + '%0D%0A' + 'Guests/s: ' + bookingData.count + '%0D%0A' + 'occasion: ' + bookingData.occasion + '%0D%0A' + 'Message: ' + bookingData.client_message + '%0D%0A%0D%0A';
      var primary = 'Guest 1%0D%0A' + 'Name: ' + bookingData.primary_user.first_name + '%0D%0A' + 'Last Name: ' + bookingData.primary_user.last_name + '%0D%0A' + 'Email: ' + bookingData.primary_user.email + '%0D%0A' + 'Telephone: ' + bookingData.primary_user.telephone_number + '%0D%0A%0D%0A';
      var guests = "";

      for (var i = 0; i < bookingData.guests.length; i++) {
        var guest_no = i + 2;
        var g = 'Guest ' + guest_no + '%0D%0A' + 'Name: ' + bookingData.guests[i].first_name + '%0D%0A' + 'Last Name: ' + bookingData.guests[i].last_name + '%0D%0A' + 'Email: ' + bookingData.guests[i].email + '%0D%0A' + 'Telephone: ' + bookingData.guests[i].telephone_number + '%0D%0A%0D%0A';
        guests += g;
      }

      var total = bookingData.price * bookingData.count;
      var promotion_code_text = '';

      if (bookingData.promo && bookingData.promo != '') {
        if (bookingData.service_category == "single") {
          var total = bookingData.price * bookingData.count - bookingData.total_discount;
        }

        promotion_code_text = bookingData.promo + ' (- HKD$ ' + bookingData.total_discount + ')';
      }

      if (bookingData.service_category != "single") {
        var total = '';
        var cost = 'Discount: ' + promotion_code_text + '%0D%0A';
      } else {
        var cost = 'Price per person: ' + bookingData.amount + '%0D%0A' + 'Discount: ' + promotion_code_text + '%0D%0A' + 'Total: HKD$ ' + total;
      }

      var sms = details + primary + guests + cost;
      var link = "mailto:?body=" + sms; // window.location = link;

      $('<a href="' + link + '" target="_blank"></a>')[0].click();
    });
    $('#wechat-share').click(function () {
      var link = "weixin://"; //window.location = link;

      $('<a href="' + link + '" target="_blank"></a>')[0].click();
    });
  });
};

export default components;